import commonReducer from './common';

export default (history) => ({
    common: commonReducer,
})